<template>
  <div>
    <div class="col-md-12">
      <div class="main-title">
        <VideoSort />
        <h6>Up Next</h6>
      </div>
    </div>
    <div class="col-md-12">
      <VideoSmall />
      <VideoSmall />
      <VideoSmall />
      <VideoSmall />
      <VideoSmall />
      <VideoSmall />
      <AdSmall />
      <VideoSmall />
      <VideoSmall />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    AdSmall: () => import('@/components/ads/AdSmall'),
    VideoSort: () => import('@/components/video/VideoSort'),
    VideoSmall: () => import('@/components/video/VideoSmall'),
  },
};
</script>
